import { Component, OnInit } from '@angular/core';
import { RibbonSelectionService } from '../../ribbon/ribbon-selection.service';
import { DialogRefs } from '../../../dialog/dialog-refs';

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.scss']
})
export class ErrorDialogComponent implements OnInit {
    constructor(
        public dialogRefs: DialogRefs<ErrorDialogComponent>,
        private ribbonSelectionService: RibbonSelectionService
    ) {}

    ngOnInit() {}

    cancel() {
        this.dialogRefs.close(false);
    }

    exit() {
        this.dialogRefs.close(true);
        this.ribbonSelectionService.selectTab(1);
    }
}
